import colorConfigs from "../../configs/colorConfigs";

const walletStyles = {
    containerBox: {
    alignItems: { xs: 'flex-start', sm: 'center' },
    textAlign: { xs: 'left', sm: 'center' },
    width: '100%',
    p: {
      xs: 1,
      sm: 3
    },
    maxWidth: { sm: '500px', xs: '400px' },
    mx: { sm: 'auto', xs: 'auto' },
  },
      card: {
        mb: 0,
        padding: 0,
        backgroundColor: colorConfigs.quaternary,
        borderRadius: '15px',
        boxShadow: 1,
        borderStyle:'solid',
        borderWidth:2,
      },
      cardContentLeft: {
        textAlign: 'left',
      },
  };

export default walletStyles;